import React from 'react';
import PropTypes from 'prop-types';

import {
  CuiButton,
  CuiGallery,
  CuiPage,
  CuiPageContent,
  CuiSiteActions,
  CuiSiteDescription,
  CuiSiteLede,
  CuiSiteTitle,
  CuiThumbnail,
} from '../../components';

export const HomePage = props => {
  const thumbnails = [];
  props.pages.forEach(page => {
    if (page.thumbnailClass) {
      thumbnails.push(
        <CuiThumbnail
          className={page.thumbnailClass}
          to={{ type: page.id }}
          label={page.name}
          key={page.id}
        />
      );
    }
  });

  return (
    <CuiPage isWide>
      <CuiPageContent>
        <CuiSiteTitle>Flexbox Patterns</CuiSiteTitle>

        <CuiSiteLede>
          Build awesome user interfaces with CSS flexbox. Examples and source
          code included.
        </CuiSiteLede>

        <CuiSiteActions>
          <CuiButton
            color="primary"
            key="source"
            iconClassName="fa fa-github"
            href="https://github.com/cjcenizal/flexbox-patterns"
          >
            Source on GitHub
          </CuiButton>

          <CuiButton
            key="twitter"
            iconClassName="fa fa-twitter"
            aria-label="Twitter"
            target="_blank"
            href="https://twitter.com/share?text=Learn%20how%20to%20build%20awesome%20UI%20components%20using%20CSS%20flexbox.&url=https://www.flexboxpatterns.com"
          >
            Tweet this
          </CuiButton>
        </CuiSiteActions>

        <CuiSiteDescription>
          Flexbox is awesome, but it introduces many new concepts that can make
          it difficult to use. These interactive examples will show you
          practical ways to use it to build UI components. They start out simple
          and get more complex near the end. You can start using these patterns
          in your own code right away, though I recommend you apply
          accessibility best practices to the markup (like using semantic HTML5
          elements).
        </CuiSiteDescription>
      </CuiPageContent>

      <CuiGallery>{thumbnails}</CuiGallery>
    </CuiPage>
  );
};

HomePage.propTypes = {
  pages: PropTypes.array,
};

HomePage.defaultProps = {
  pages: [],
};



// WEBPACK FOOTER //
// ./ui/views/home/HomePage.js